module.exports = __webpack_public_path__ + "img/Status-Server Monitor-Report-Main.a3ea5a09.png";